<mat-expansion-panel [expanded]="!collapsed">
    <mat-expansion-panel-header>
        {{to.title}}
    </mat-expansion-panel-header>

    <ng-template #section matExpansionPanelContent>
    </ng-template>
</mat-expansion-panel>
